import type { DatePickerValues } from '@latitude/datepicker';
import { Datepicker } from '@latitude/datepicker';
import type { FieldValues } from 'react-hook-form';

import type { InternalFormDatepickerProps } from './types';

export const InternalFormDatepicker = <T extends FieldValues = FieldValues>({
  mode,
  onChange,
  onBlur,
  disabled,
  onClear,
  ...props
}: InternalFormDatepickerProps<T>) => {
  return (
    <Datepicker
      mode={mode}
      onChange={(
        pickerValues:
          | DatePickerValues<'single' | 'time' | 'single-time'>
          | DatePickerValues<'range'>,
      ) => onChange(pickerValues.value)}
      disabled={disabled}
      onBlur={onBlur}
      onClear={() => {
        onChange(null);
        onClear?.();
      }}
      {...props}
    />
  );
};
